var render = function (_h,_vm) {var _c=_vm._c;return _c('b-button',_vm._g(_vm._b({class:[
        Object.assign({}, {'btn-wide': _vm.props.wide,
            'btn-bold': _vm.props.bold,
            'btn-icon': _vm.props.iconOnly,
            'kt-spinner kt-spinner--light kt-spinner--right': _vm.props.loading},
            _vm.data.class),
        _vm.data.staticClass ]},'b-button',_vm.data.attrs,false),_vm.listeners),[_c('div',{staticClass:"align-items-center justify-content-center d-flex"},[(_vm.props.icon)?_c('v-icon',{attrs:{"icon":_vm.props.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }